/**
 * CSS class names applied to `<html>` element based on scroll direction.
 */
export const SCROLL_CLASS_NAMES = {
  SCROLL_FORWARD: "-scroll-forward",
  SCROLL_BACKWARD: "-scroll-backward",
  SCROLLING_FORWARD: "-scrolling-forward",
  SCROLLING_BACKWARD: "-scrolling-backward",
} as const;
